import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'

import { queryCompanyGet } from '@api/company/company.queries'

import NotFoundResource from '@/components/router/not-found-resource'

const params = z.object({
  uuid: z.uuid(),
})

const backToLink = linkOptions({
  to: '/app/data/companies',
})

export const Route = createFileRoute('/app/data/companies/$uuid')({
  component: RouteComponent,
  params,
  loader: ({ params, context: { queryClient } }) => {
    queryClient.prefetchQuery(queryCompanyGet(params.uuid))
  },
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.company.resource-type')}
        backTo={t(
          'resource-not-found.not-found.company.back-to-companies-list',
        )}
        backToLink={backToLink}
      />
    )
  },
})

function RouteComponent() {
  return <Outlet />
}
